$(document).ready(function (e) {
//Save info
    let regexARSuc = /\/fotos\/index\/Save\/Success/;
    let regexARFail = /\/fotos\/index\/Save\/Failed$/;

    if (regexARSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Foto\'s', '/Fotos');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexARFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Foto\'s', '/Fotos');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/fotos.js
// module id = 17
// module chunks = 0